'use strict';
'use es6';

/**
 * Detect if a mouseevent occurred within a given rectangle of UI coordinates
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isCursorOver = exports.isCursorOver = function isCursorOver(boundingClientRect, mouseEvent) {
  var top = boundingClientRect.top,
      bottom = boundingClientRect.bottom,
      left = boundingClientRect.left,
      right = boundingClientRect.right;
  var X = mouseEvent.clientX,
      Y = mouseEvent.clientY;


  return X >= left && X <= right && Y <= bottom && Y >= top;
};

/**
 * Detect if a mouseevent occurred within a given rectangle of UI coordinates
 **/
var isOverlapping = exports.isOverlapping = function isOverlapping(rect1, rect2) {
  return rect1.top < rect2.bottom && rect2.top < rect1.bottom && rect1.left < rect2.right && rect2.left < rect1.right;
};

/**
 * Return the rectangular coordinates of the max area containing both elements
 *
 * @returns Object {top: Number, bottom: Number, left: Number, right: Number}
 **/
var calculateSurroundingRect = function calculateSurroundingRect(target, tooltip) {
  return {
    top: Math.min(tooltip.top, target.top),
    bottom: Math.max(tooltip.bottom, target.bottom),
    left: Math.min(tooltip.left, target.left),
    right: Math.max(tooltip.right, target.right)
  };
};

/**
 * Determine if a tooltip should close, given the target coords, tooltip coords,
 * placement config of the tooltip, and the originating mouse event
 **/
var shouldTooltipClose = exports.shouldTooltipClose = function shouldTooltipClose(target, tooltip, mouseEvent) {
  return !isCursorOver(calculateSurroundingRect(target, tooltip), mouseEvent);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/tooltip/utils/Hover.js
// module id = 174
// module chunks = 0